import AuthMiddleware from "@/middleware/auth"
import store from "@/store"

const NewOrder = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/NewPatientOrder")
const AllOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/AllOrders")
const ActiveOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/ActiveOrders")
const CompleteOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/CompleteOrders")
const ArchiveOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/ArchiveOrders")
const RejectionOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/RejectionOrders")
const PendingOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/PendingOrders")
const ViewOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/ViewOrder")

const PartialOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/PartialOrders")

const PartiallyRejectedOrders = () =>
  import(
    /* webpackChunkName: "orders" */ "@/views/orders/PartiallyRejectedOrders"
  )
const RequiresAttentionOrders = () =>
  import(
    /* webpackChunkName: "orders" */ "@/views/orders/RequiresAttentionOrders.vue"
  )
const CollectedSamplesOrders = () =>
  import(
    /* webpackChunkName: "orders" */ "@/views/orders/CollectedSamplesOrders.vue"
  )
const ValidationOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/ValidationOrders")
const SampleAckOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/SampleAckOrders")
const InsuranceOnHoldOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/InsuranceOnHoldOrders")
const AddOnTestsOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/AddOnTestsOrders")
// TestGo orders are not available to APEX lab users.
const ordersAccess = (to, from, next) => {
  const allowedLabs = store.getters["auth/getUserAllowedLabs"]
  const primaryLabId = store.getters["auth/getUserPrimaryLabId"]
  const currentLab =
    allowedLabs && primaryLabId
      ? allowedLabs.find((lab) => lab._id === primaryLabId)
      : null
  if (currentLab && currentLab.lab_code == "APX") {
    next({ name: "AllCases" })
    return
  }
  AuthMiddleware.user(to, from, next)
}

const OrdersRouter = [
  {
    path: "/new-order",
    name: "NewOrder",
    component: NewOrder,
    beforeEnter: ordersAccess,
    meta: {
      title: "NEW ORDER",
    },
  },

  {
    path: "/all-orders",
    name: "AllOrders",
    component: AllOrders,
    beforeEnter: ordersAccess,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },

  {
    path: "/all-orders/active",
    name: "ActiveOrders",
    beforeEnter: ordersAccess,
    component: ActiveOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/finalized",
    name: "CompleteOrders",
    beforeEnter: ordersAccess,
    component: CompleteOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/archive",
    name: "ArchiveOrders",
    beforeEnter: ordersAccess,
    component: ArchiveOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/partial",
    name: "PartialOrders",
    beforeEnter: ordersAccess,
    component: PartialOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/rejection",
    name: "RejectionOrders",
    beforeEnter: ordersAccess,
    component: RejectionOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/partially-rejected",
    name: "PartiallyRejectedOrders",
    beforeEnter: ordersAccess,
    component: PartiallyRejectedOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/requires-attention",
    name: "RequiresAttentionOrders",
    beforeEnter: ordersAccess,
    component: RequiresAttentionOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/collected-samples",
    name: "CollectedSamplesOrders",
    beforeEnter: ordersAccess,
    component: CollectedSamplesOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/pending",
    name: "PendingOrders",
    beforeEnter: ordersAccess,
    component: PendingOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/sample-acknowledgement",
    name: "SampleAckOrders",
    beforeEnter: ordersAccess,
    component: SampleAckOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/insurance-on-hold",
    name: "InsuranceOnHoldOrders",
    beforeEnter: ordersAccess,
    component: InsuranceOnHoldOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/add-on-tests",
    name: "AddOnTestsOrders",
    beforeEnter: ordersAccess,
    component: AddOnTestsOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/orders/:order_id/edit",
    name: "Edit-Order-Info",
    component: NewOrder,
    beforeEnter: ordersAccess,
    meta: {
      title: "EDIT LABSQUIRE ORDER",
    },
  },

  {
    path: "/orders/:order_id",
    name: "Order-Information",
    component: ViewOrders,
    beforeEnter: ordersAccess,
  },
  {
    path: "/validation-orders",
    name: "ValidationOrders",
    component: ValidationOrders,
    beforeEnter: ordersAccess,
    meta: {
      title: "VALIDATION TESTGO ORDERS",
    },
  },
]

export { OrdersRouter }
